
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SCON",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SCON.vue